export default __webpack_public_path__ + "static/media/Proreview-6.446818bb.jpg";